/* ═══════════════════════════════════════════
   CONFIG — live GC booking system (Microsoft Bookings)
═══════════════════════════════════════════ */
const BOOKING_URL = "https://outlook.office.com/book/GameChanger@gccoaching.co/?ismsaljsauthenabled";

/* ═══════════════════════════════════════════
   PAGE ROUTING — falls back to real URL navigation
   when SPA elements are not in the DOM
═══════════════════════════════════════════ */
const GC_PAGE_URLS = {
  'home': '/',
  'way': '/pages/the-way',
  'work': '/pages/the-work',
  'about': '/pages/about',
  'collab': '/pages/collaborations',
  'media': '/pages/media-writing',
  'immersive': '/pages/the-immersive',
  'packages': '/pages/packages',
  'friendshop': '/pages/the-friendshop',
  'access': '/pages/access-pathway',
  'community': '/pages/community',
  'shop': '/pages/shop',
  'testimonials': '/pages/clients'
};

function showPage(id) {
  const target = document.getElementById('page-' + id);
  if (!target) {
    if (GC_PAGE_URLS[id]) window.location.href = GC_PAGE_URLS[id];
    return;
  }
  const pageIds = Object.keys(GC_PAGE_URLS);
  pageIds.forEach(p => {
    const el = document.getElementById('page-' + p);
    if (el) el.classList.remove('active');
    const navEl = document.getElementById('nav-' + p);
    if (navEl) navEl.classList.remove('active');
  });
  target.classList.add('active');
  const navTarget = document.getElementById('nav-' + id);
  if (navTarget) navTarget.classList.add('active');
  window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
}

/* ═══════════════════════════════════════════
   MOBILE NAV
═══════════════════════════════════════════ */
function toggleMobileNav() {
  const nav = document.getElementById('mobileNav');
  if (nav) nav.classList.toggle('open');
}

/* ═══════════════════════════════════════════
   NAV SCROLL STATE
═══════════════════════════════════════════ */
window.addEventListener('scroll', () => {
  const nav = document.getElementById('gcNav');
  if (nav) {
    if (window.scrollY > 20) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  }
});

/* ═══════════════════════════════════════════
   BOOKING — opens the live GC Microsoft Bookings page
═══════════════════════════════════════════ */
function openCalendly() {
  window.open(BOOKING_URL, '_blank', 'noopener');
}

/* ═══════════════════════════════════════════
   IMMERSIVE APPLICATION FORM
   NOTE: front-end prototype — connect to Formspree before launch (see Prompt 20)
═══════════════════════════════════════════ */
function toggleAccessNote() {
  const val = document.getElementById('budgetSelect').value;
  const note = document.getElementById('accessNote');
  if (note) note.style.display = (val === 'not-yet') ? 'block' : 'none';
}

function submitImmersiveForm(e) {
  e.preventDefault();
  const form = document.getElementById('immersiveForm');
  const success = document.getElementById('immersiveSuccess');
  const btn = form ? form.querySelector('[type="submit"]') : null;

  if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }

  const fd = new FormData(form);
  fd.append('_subject', 'Immersive Application — ' + (fd.get('name') || ''));
  fd.append('_cc', 'tom@gccoaching.co');
  fd.append('_captcha', 'false');
  fd.append('_template', 'table');

  fetch('https://formsubmit.co/ajax/jake@gccoaching.co', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: fd
  })
  .then(function() {
    if (form) form.style.display = 'none';
    if (success) { success.style.display = 'block'; success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  })
  .catch(function() {
    if (btn) { btn.textContent = 'Submit application →'; btn.disabled = false; }
    alert('Something went wrong — please try again or email jake@gccoaching.co directly.');
  });
}

function submitAccessForm(e) {
  e.preventDefault();
  const form = document.getElementById('accessForm');
  const success = document.getElementById('accessSuccess');
  const btn = form ? form.querySelector('[type="submit"]') : null;

  if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }

  const fd = new FormData(form);
  fd.append('_subject', 'Access Program Application — ' + (fd.get('name') || ''));
  fd.append('_cc', 'tom@gccoaching.co');
  fd.append('_captcha', 'false');
  fd.append('_template', 'table');

  fetch('https://formsubmit.co/ajax/jake@gccoaching.co', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: fd
  })
  .then(function() {
    if (form) form.style.display = 'none';
    if (success) { success.style.display = 'block'; success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  })
  .catch(function() {
    if (btn) { btn.textContent = 'Submit to the panel →'; btn.disabled = false; }
    alert('Something went wrong — please try again or email jake@gccoaching.co directly.');
  });
}

function submitFsEnquireForm(e) {
  e.preventDefault();
  const form = document.getElementById('fsEnquireForm');
  const success = document.getElementById('fsEnquireSuccess');
  const btn = form ? form.querySelector('[type="submit"]') : null;

  if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }

  const fd = new FormData(form);
  fd.append('_subject', 'Friendshop Enquiry — ' + (fd.get('name') || ''));
  fd.append('_cc', 'tom@gccoaching.co');
  fd.append('_captcha', 'false');
  fd.append('_template', 'table');

  fetch('https://formsubmit.co/ajax/jake@gccoaching.co', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: fd
  })
  .then(function() {
    if (form) form.style.display = 'none';
    if (success) { success.style.display = 'block'; success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  })
  .catch(function() {
    if (btn) { btn.textContent = 'Send enquiry →'; btn.disabled = false; }
    alert('Something went wrong — please try again or email jake@gccoaching.co directly.');
  });
}

/* ═══════════════════════════════════════════
   CART / TOAST
═══════════════════════════════════════════ */
let gcCartCount = 0;
function addToCart(itemLabel) {
  gcCartCount++;
  const countEl = document.getElementById('cartCount');
  if (countEl) countEl.textContent = gcCartCount;
  showToast('Added — ' + itemLabel.split(' — ')[0]);
}
function showToast(msg) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(() => toast.classList.remove('show'), 2600);
}

/* ═══════════════════════════════════════════
   BUILD YOUR OWN BUNDLE
═══════════════════════════════════════════ */
function updateBundle() {
  const checked = Array.from(document.querySelectorAll('.byob-item input:checked'));
  const subtotal = checked.reduce((sum, el) => sum + parseFloat(el.dataset.price), 0);
  const qualifies = checked.length >= 3;
  const discount = qualifies ? subtotal * 0.15 : 0;
  const total = subtotal - discount;

  const countEl = document.getElementById('byobCount');
  const wasEl = document.getElementById('byobWas');
  const totalEl = document.getElementById('byobTotal');
  const btn = document.getElementById('byobAddBtn');

  if (countEl) {
    if (checked.length === 0) {
      countEl.textContent = 'Select 3 or more items to unlock 15% off.';
    } else if (!qualifies) {
      countEl.textContent = (3 - checked.length) + ' more item' + (3 - checked.length === 1 ? '' : 's') + ' to unlock 15% off.';
    } else {
      countEl.textContent = checked.length + ' items — 15% off applied.';
    }
  }

  if (wasEl) wasEl.textContent = qualifies ? ('$' + subtotal.toFixed(0)) : '';
  if (totalEl) totalEl.textContent = '$' + total.toFixed(0);
  if (btn) btn.disabled = checked.length < 1;
}

function addBundleToCart() {
  const checked = Array.from(document.querySelectorAll('.byob-item input:checked'));
  if (checked.length === 0) return;
  const subtotal = checked.reduce((sum, el) => sum + parseFloat(el.dataset.price), 0);
  const qualifies = checked.length >= 3;
  const total = qualifies ? subtotal * 0.85 : subtotal;
  gcCartCount += checked.length;
  const countEl = document.getElementById('cartCount');
  if (countEl) countEl.textContent = gcCartCount;
  showToast('Bundle added — ' + checked.length + ' items, $' + total.toFixed(0));
}

/* ═══════════════════════════════════════════
   SHOP FILTER
═══════════════════════════════════════════ */
function shopFilter(btn, cat) {
  document.querySelectorAll('.shop-filter').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
  document.querySelectorAll('#shopGrid > [data-cat]').forEach(card => {
    const cardCat = card.getAttribute('data-cat');
    card.style.display = (cat === 'all' || cardCat === cat || cardCat === 'all') ? '' : 'none';
  });
}

/* ═══════════════════════════════════════════
   EMAIL CAPTURE — GC Coherence Self-Assessment
   NOTE: front-end prototype — connect to email backend before launch
═══════════════════════════════════════════ */
function handleCapture(e) {
  e.preventDefault();
  const form = e.target;
  const email = form.querySelector('input[type="email"]').value;
  const btn = form.querySelector('button[type="submit"]');
  if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }
  fetch('https://formsubmit.co/ajax/jake@gccoaching.co', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ email: email, _subject: 'GC Coherence Self-Assessment — Signup', message: 'Self-assessment signup: ' + email, _cc: 'tom@gccoaching.co', _captcha: 'false', _template: 'table' })
  }).then(function() {
    const block = document.getElementById('capture-block');
    if (block) {
      block.innerHTML = '<div class="eyebrow" style="justify-content:center;">Almost there</div>' +
        '<h3>Check your <em>inbox</em></h3>' +
        '<p>Your GC Coherence Self-Assessment is on its way. If it doesn\'t arrive in a few minutes, check spam.</p>';
    }
    showToast('Sent — check your inbox shortly');
  }).catch(function() {
    if (btn) { btn.textContent = 'Send it to me'; btn.disabled = false; }
    showToast('Something went wrong — please try again');
  });
}

/* ═══════════════════════════════════════════
   ESC KEY CLOSES MOBILE NAV
═══════════════════════════════════════════ */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const nav = document.getElementById('mobileNav');
    if (nav) nav.classList.remove('open');
  }
});

/* ═══════════════════════════════════════════
   STICKY PREVIEW POPUPS
   Keeps popup open while cursor moves from
   trigger to popup across the gap.
═══════════════════════════════════════════ */
(function () {
  document.querySelectorAll('.gc-preview-wrap').forEach(function (wrap) {
    var popup = wrap.querySelector('.gc-preview-popup');
    if (!popup) return;
    var timer;
    wrap.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      popup.style.display = 'block';
    });
    wrap.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { popup.style.display = 'none'; }, 200);
    });
    popup.addEventListener('mouseenter', function () {
      clearTimeout(timer);
    });
    popup.addEventListener('mouseleave', function () {
      popup.style.display = 'none';
    });
  });
})();
